import React from 'react'
import { useLocation } from 'react-router-dom'
import { REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN } from '../config/settings/environment'
import WizardLayout from '../components/Layouts/WizardLayout'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import NotFoundPage from './NotFound'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import RegisterWizardWelcomeContainer from '../containers/RegisterWizard/Step0/RegisterWizardWelcome.container'
import RegisterWizardUniquePassContainer from '../containers/RegisterWizard/Step1/RegisterWizardUniquePass.container'
import RegisterWizardPersonalInformationContainer from '../containers/RegisterWizard/Step1/RegisterWizardPersonalInformation.container'
import RegisterWizardEmailVerifyContainer from '../containers/RegisterWizard/Step2/RegisterWizardEmailVerify.container'
import RegisterWizardBusinessSearchContainer from '../containers/RegisterWizard/Step3/RegisterWizardBusinessSearch.container'
import RegisterWizardBusinessInformationContainer from '../containers/RegisterWizard/Step3/RegisterWizardBusinessInformation.container'
import RegisterWizardRecoveryCompanyContainer from '../containers/RegisterWizard/Step3/RegisterWizardRecoveryCompany.container'
import RegisterWizardRepresentativeAuthorityContainer from '../containers/RegisterWizard/Step4/RegisterWizardRepresentativeAuthority.container'
import RegisterWizardCollaborationAgreementContainer from '../containers/RegisterWizard/Step5/RegisterWizardCollaborationAgreement.container'
import RegisterWizardCollaborationVolunteersContainer from '../containers/RegisterWizard/Step5/RegisterWizardCollaborationVolunteers.container'
import RegisterWizardCompleteContainer from '../containers/RegisterWizard/Step6/RegisterWizardComplete.container'
import { BusinessIcon, CheckIcon, FileSignIcon, MailIcon, PersonIcon, ProfileIcon } from './RegisterWizard.styles'
import { useEffectOnce } from '@chilecompra/react-kit'
import { initializeRecaptcha } from '../modules/hooks/recaptcha'

/**
 * The RegisterWizard's page.
 */
const RegisterWizard = () => {
  const location = useLocation()
  const { state } = location

  useEffectOnce(() => {
    initializeRecaptcha()
  })

  return (
    <ProtectByFeatures rule={features => features['com.buyer/register.wizard']} fallback={() => <NotFoundPage />}>
      <AuthorizationProviderContainer>
        <ProtectByAccessToken fallback={() => <NotFoundPage />}>
          <WizardLayout
            defaultStepID={state?.defaultStepID || 'welcome'}
            steps={[
              {
                component: <RegisterWizardWelcomeContainer />,
                id: 'welcome',
                number: 0,
                showNumber: false,
                hiddenWhen: []
              },
              {
                component: <RegisterWizardUniquePassContainer />,
                icon: <PersonIcon size="1.5em" />,
                id: 'by-unique-pass',
                name: 'Información personal',
                number: 1,
                showNumber: true,
                hiddenWhen: []
              },
              {
                component: <RegisterWizardPersonalInformationContainer />,
                icon: <PersonIcon size="1.5em" />,
                id: 'personal-info',
                name: 'Información personal',
                number: 1,
                showNumber: true,
                hiddenWhen: []
              },
              {
                component: <RegisterWizardEmailVerifyContainer />,
                icon: <MailIcon size="1.3em" />,
                id: 'email-verify',
                name: 'Correo electrónico',
                number: 2,
                showNumber: true,
                hiddenWhen: []
              },
              {
                component: <RegisterWizardBusinessSearchContainer />,
                icon: <BusinessIcon size="1.3em" />,
                id: 'business-search',
                name: 'Registrar institución',
                number: 3,
                showNumber: true,
                hiddenWhen: []
              },
              {
                component: <RegisterWizardBusinessInformationContainer />,
                icon: <BusinessIcon size="1.3em" />,
                id: 'business-info',
                name: 'Registrar institución',
                number: 3,
                showNumber: true,
                hiddenWhen: []
              },
              [true, 'true'].includes(REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN) && {
                component: <RegisterWizardRecoveryCompanyContainer />,
                icon: <BusinessIcon size="1.3em" />,
                id: 'recovery-company',
                name: 'Recuperar institución',
                number: 3,
                showNumber: true,
                hiddenWhen: []
              },
              {
                component: <RegisterWizardRepresentativeAuthorityContainer />,
                icon: <ProfileIcon src="/assets/icons/icono_profile.svg" size="1.3em" />,
                id: 'representative-authority',
                name: 'Autoridad representante',
                number: 4,
                showNumber: true,
                hiddenWhen: ['recovery-company']
              },
              {
                component: <RegisterWizardCollaborationAgreementContainer />,
                icon: <FileSignIcon src="/assets/icons/icono_file_sign.svg" size="1.3em" />,
                id: 'collaboration-agreement',
                name: 'Convenio de adhesión',
                number: 5,
                showNumber: true,
                hiddenWhen: ['recovery-company']
              },
              {
                component: <RegisterWizardCollaborationVolunteersContainer />,
                icon: <FileSignIcon src="/assets/icons/icono_file_sign.svg" size="1.3em" />,
                id: 'volunteers-agreement',
                name: 'Convenio de colaboración',
                number: 5,
                showNumber: true,
                hiddenWhen: ['recovery-company']
              },
              {
                component: <RegisterWizardCompleteContainer />,
                icon: <CheckIcon size="1.3em" />,
                id: 'complete',
                name: 'Envío de solicitud',
                number: 6,
                showNumber: false,
                hiddenWhen: ['recovery-company']
              }
            ].filter(Boolean)}
          />
        </ProtectByAccessToken>
      </AuthorizationProviderContainer>
    </ProtectByFeatures>
  )
}

export default RegisterWizard
